import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormProfile({
  profileSelect,
  callback,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [infoModules, setInfoModule] = useState(false);
  const [infoPermission, setInfoPermission] = useState(false);
  const [infoForm, setForm] = useState({
    name: '',
    state: true,
    modules: [],
    permissions: [],
  });
  const callbackRef = useRef(callback);
  const handleClose = () => setShow(false);
  const handleShow = async (Profile) => {
    if (Profile) {
      const infoProfile = await get('/profile/' + Profile);
      if (infoProfile.success) {
        const { name, state, modules, permissions } = infoProfile.data;
        setForm({
          name,
          state,
          modules,
          permissions
        });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = {
      name: infoForm.name,
      state: infoForm.state,
      modules: infoForm.modules,
      permissions: infoForm.permissions,
    };

    if (profileSelect) {
      respo = await put('/profile/modify/' + profileSelect, body);
      msg = 'Tipo editado Correctamente';
    } else {
      respo = await post('/profile/create', body);
      msg = 'Tipo Creado Correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    setForm({
      name: '',
      state: true,
      modules: [],
      permissions: [],
    });
    handleClose();
    callback(variant, msg);
  };

  const validCheckedModule = (id) => {
    if (infoForm.modules?.length > 0) {
      const valid =
        infoForm.modules.findIndex((element) => element === id) >= 0
          ? true
          : false;
      return valid;
    } else {
      return false;
    }
  };

  const validCheckedPermission = (id) => {
    if (infoForm.permissions?.length > 0) {
      const valid =
        infoForm.permissions.findIndex((element) => element === id) >= 0
          ? true
          : false;
      return valid;
    } else {
      return false;
    }
  };

  const handleFormSelect = ({ target }, type) => {
    const value = parseInt(target.name);
    const arrayForm = infoForm[type];

    if (target.checked) {
      arrayForm.push(value);
    } else {
      const control = arrayForm.findIndex((element) => element === value);
      if (control >= 0) arrayForm.splice(control, 1);
    }
    setForm({ ...infoForm, [type]: arrayForm });
  };

  useEffect(() => {
    const getModules = async () => {
      const resModule = await get('/profile/modules/', {});
      if (resModule.success) {
        setInfoModule(resModule.data.modules_list);
        setInfoPermission(resModule.data.permission_list)
      } else {
        callbackRef.current('danger', resModule.message);
      }
    };
    if (show) getModules();
  }, [show, callbackRef]);

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(profileSelect)}
      />

      <Modal animation={false} size="lg" fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Form.Label htmlFor="nombre">Nombre</Form.Label>
              <Form.Control
                name="name"
                value={infoForm.name}
                onChange={(e) => handleForm(e)}
                type="text"
              />
            </Row>
            <Form.Check
              className="mb-4"
              type="switch"
              name="state"
              label="Activo"
              checked={infoForm.state}
              onChange={(e) => handleForm(e)}
            />
            <Row className="mt-3">Permisos</Row>
            <Row className="mt-3">
              {infoPermission && (
                <Row>
                  {infoPermission.map((element, i) => (
                    <Col key={i} lg={4} sm={12} md={6}>
                      <Form.Check
                        type="switch"
                        id={element.id}
                        name={element.id}
                        label={element.description}
                        checked={validCheckedPermission(element.id)}
                        onChange={(e) => handleFormSelect(e, 'permissions')}
                      />
                    </Col>
                  ))}
                </Row>
              )}
            </Row>
            <Row className="mt-3">Modulos</Row>
            <Row className="mt-3">
              {infoModules && (
                Object.entries(
                  infoModules.reduce((acc, element) => {
                    // Group modules by id_category__name
                    const categoryName = element.id_category__name;
                    if (!acc[categoryName]) {
                      acc[categoryName] = [];
                    }
                    acc[categoryName].push(element);
                    return acc;
                  }, {})
                ).map(([categoryName, elements], index) => (
                  <div key={index} className="mt-3">
                    <h5>{categoryName}</h5> {/* Display category name */}
                    <Row>
                      {elements.map((element, i) => (
                        <Col key={i} lg={4} sm={12} md={6}>
                          <Form.Check
                            type="switch"
                            id={element.id}
                            name={element.id}
                            label={element.name}
                            checked={validCheckedModule(element.id)}
                            onChange={(e) => handleFormSelect(e, 'modules')}
                          />
                        </Col>
                      ))}
                    </Row>
                  </div>
                ))
              )}
            </Row>

            <Row className="text-center m-3">
              <Col>
                <Button variant="secondary">Limpiar Formulario</Button>
              </Col>
              <Col>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormProfile;
